@if (matIconButton) {
    <button
        type="button"
        mat-icon-button
        [class]="buttonClass"
        [matTooltip]="tooltipKey | transloco"
        [matTooltipDisabled]="!showTooltip"
        (click)="themeService.toggle()"
    >
        <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
} @else {
    <button
        type="button"
        [class]="buttonClass"
        [matTooltip]="tooltipKey | transloco"
        [matTooltipDisabled]="!showTooltip"
        (click)="themeService.toggle()"
    >
        <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
}
